import createProperty from './create-property';

export default createProperty({
  default: 0,
  validate(v) {
    return typeof v === 'number';
  },
});
